// @ts-check
import React from "react";
import WhatsAppCard from "./WhatsAppCard";
import { useSelector } from "react-redux";
import TelegramImg from "../../assets/images/icons/telegramfoot.png";
import FbIconImg from "../../assets/images/provider/facebook.png";
import InstaIconImg from "../../assets/images/provider/instagram.png";
import WhatsaPPImg from "../../assets/images/icons/whatsappfoot.png";

const SocialMediaComponent = () => {
  // @ts-ignore
  const { appDetails } = useSelector((state) => state.app);

  return (
    <div className="social-icons">
      <ul>
        <li>
          <SocialMediaCard redirectionUrl={appDetails?.FACEBOOK}>
            <img src={FbIconImg} />
          </SocialMediaCard>
        </li>
        <li>
          <SocialMediaCard redirectionUrl={appDetails?.INSTATGRAM}>
            <img src={InstaIconImg} />
          </SocialMediaCard>
        </li>
        <li>
          <SocialMediaCard redirectionUrl={appDetails?.TELEGRAM}>
            <img src={TelegramImg} />
          </SocialMediaCard>
        </li>
        <li>
          <WhatsAppCard url={appDetails?.WHATS_APP_URL}>
            <img src={WhatsaPPImg} />
          </WhatsAppCard>
        </li>
      </ul>
    </div>
  );
};

export default SocialMediaComponent;

/**
 *
 * @param {string} url
 * @returns {string}
 */
const getFormattedUrl = (url) => {
  if (!url || url == "") {
    return "";
  }
  return url;
};

/**
 *
 * @param {{redirectionUrl:string; children:React.ReactNode}} param0
 */
export const SocialMediaCard = ({ redirectionUrl = "", children }) => {
  return (
    <a
      href={getFormattedUrl(redirectionUrl)}
      target={getFormattedUrl(redirectionUrl) !== "" ? "_blank" : ""}
    >
      {children}
    </a>
  );
};
